import { apiClient } from "../apiClient";

export const sendTestEmail = async (email: string) => {
    return apiClient.post(`/Email/SendTestEmail`, { email });
};
